module.exports = __webpack_public_path__ + "static/media/printerRoll.aa5e491f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/printerRoll.png
// module id = 1642
// module chunks = 0